/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LegacyTournamentGroupSlotCreateRequest
 */
export interface LegacyTournamentGroupSlotCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof LegacyTournamentGroupSlotCreateRequest
     */
    slotIndex: number;
    /**
     * 
     * @type {number}
     * @memberof LegacyTournamentGroupSlotCreateRequest
     */
    seed?: number;
}

/**
 * Check if a given object implements the LegacyTournamentGroupSlotCreateRequest interface.
 */
export function instanceOfLegacyTournamentGroupSlotCreateRequest(value: object): value is LegacyTournamentGroupSlotCreateRequest {
    if (!('slotIndex' in value) || value['slotIndex'] === undefined) return false;
    return true;
}

export function LegacyTournamentGroupSlotCreateRequestFromJSON(json: any): LegacyTournamentGroupSlotCreateRequest {
    return LegacyTournamentGroupSlotCreateRequestFromJSONTyped(json, false);
}

export function LegacyTournamentGroupSlotCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegacyTournamentGroupSlotCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'slotIndex': json['slotIndex'],
        'seed': json['seed'] == null ? undefined : json['seed'],
    };
}

export function LegacyTournamentGroupSlotCreateRequestToJSON(json: any): LegacyTournamentGroupSlotCreateRequest {
    return LegacyTournamentGroupSlotCreateRequestToJSONTyped(json, false);
}

export function LegacyTournamentGroupSlotCreateRequestToJSONTyped(value?: LegacyTournamentGroupSlotCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'slotIndex': value['slotIndex'],
        'seed': value['seed'],
    };
}

